import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { RefreshPropertyHelper } from '../../../../ts/helpers/RefreshPropertyHelper';
import { IDataSourceDetailInfo } from '../../../../ts/models/IDataSourceInfo';
import { ChangeScheduleAction } from '../../../../ts/services/ChangeScheduleAction';
import { CreateExtractTasksAction, CreateExtractTasksMode } from '../../../../ts/services/CreateExtractTasksAction';
import { CreateRemoteRefreshScheduleAction } from '../../../../ts/services/CreateRemoteRefreshScheduleAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { CreateRemoteExtractRefreshAction } from '../../../actions/spaces/CreateRemoteExtractRefreshAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleCreateRemoteExtractRefreshAction(action: CreateRemoteExtractRefreshAction) {
  try {
    if (FeatureFlags.bridgeServerTriggeredClientSideRefresh) {
      // Similar to the logic of openDatasourceRefreshExtractDialog 
      // in $\src\vizportalclient\src\app\sagas\spaces\extractTasks\CreateExtractRefreshSaga.ts
      // such that clicking "New Extract Refresh" would open the same tabbed dialog
      const createExtractModule = ServiceLocator.get<CreateExtractTasksAction>('CreateExtractTasksAction');
      const context = ServiceLocator.getAngularActionContext();
      createExtractModule.forDatasource(action.datasource, context, CreateExtractTasksMode.AllowScheduleOnServerAndClient);
    } else {
      yield call(executeCreateRemoteExtractRefreshAction, action.datasource);
    }
    yield put(requestSpaceContents());
  } catch(e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeCreateRemoteExtractRefreshAction(datasource: IDataSourceDetailInfo) {
  const createRemoteExtractRefreshService =
      ServiceLocator.get<CreateRemoteRefreshScheduleAction>('CreateRemoteRefreshScheduleAction');
  const changeScheduleService = ServiceLocator.get<ChangeScheduleAction>('ChangeScheduleAction');
  const context = ServiceLocator.getAngularActionContext();
  const availableRefreshTypes = RefreshPropertyHelper.getAvailableRefreshTypes(datasource);
  return createRemoteExtractRefreshService.execute(context, datasource, availableRefreshTypes, changeScheduleService);
}
